import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectsListApi, getUserListApi } from '@src/api';
import { GetProjectsParams } from '@src/api/projects/projects';

const getGuideList = createAsyncThunk(
  'get/guideList',
  async (params: GetProjectsParams, { rejectWithValue }) => {
    try {
      const response = await getProjectsListApi(params);
      return response.result.data;
    } catch (err) {
      throw rejectWithValue(err);
    }
  }
);

const getPicSuggestionList = createAsyncThunk(
  'get/adminUser',
  async (search: string, { rejectWithValue }) => {
    try {
      const response = await getUserListApi({
        filter: { role: 'admin' },
        searchBy: 'name',
        search,
      });
      return response.result.data.data;
    } catch (err) {
      throw rejectWithValue(err);
    }
  }
);

export { getGuideList, getPicSuggestionList };
